export default __webpack_public_path__ + "static/media/moneybag.0bce3762.svg";